import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootStateInterface } from "../interfaces/ReduxInterface";

export const useTypedSelector: TypedUseSelectorHook<RootStateInterface> =
  useSelector;
